module.exports = __webpack_public_path__ + "img/he_zuo_zi_xun.7cb70cd4.png";